'use client'
import Image from 'next/image'
import { useState, type ComponentPropsWithRef, type CSSProperties } from 'react'

type SmoothImageProps = ComponentPropsWithRef<typeof Image> & {
    fadeIn?: boolean
}

const SmoothImage = (props: SmoothImageProps) => {
    const { onLoad, fadeIn = false, alt, ...otherProps } = props
    const [imageLoaded, setImageLoaded] = useState(false)
    const [imageLoadingComplete, setImageLoadingComplete] = useState(false)

    const handleOnLoad = (event: React.SyntheticEvent<HTMLImageElement>): void => {
        if (onLoad) {
            onLoad(event)
        }
        setImageLoaded(true)
    }

    const style: CSSProperties = (() => {
        if (fadeIn) {
            return imageLoadingComplete ? {} : { opacity: imageLoaded ? 1 : 0, transition: 'opacity 300ms ease-in-out' }
        }
        return {}
    })()
    return (
        <Image
            onTransitionEnd={() => {
                setImageLoadingComplete(true)
            }}
            alt={alt}
            style={style}
            onLoad={handleOnLoad}
            {...otherProps}
        />
    )
}

SmoothImage.displayName = 'SmoothImage'

export default SmoothImage
